import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import info from "../utils/info";
import SignIn from "../views/admin/SignIn.vue";
import Dashboard from "../views/admin/Dashboard.vue";
import DashboardHome from "../views/admin/DashboardHome.vue";
import NotFound from "../views/NotFound.vue";
import SocialMedia from "../views/admin/SocialMedia.vue";
import ResetPassword from "../views/admin/ResetPassword.vue";
import Users from "../views/admin/Users.vue";
import Audit from "../views/admin/Audit.vue";
import Settings from "../views/admin/Settings.vue";
import Service from "../views/admin/Service.vue";
import Vacant from "../views/admin/Vacant.vue";
import Post from "../views/admin/Post.vue";
import Section from "../views/admin/Section.vue";
import FixedTerms from "../views/admin/FixedTerms.vue";
import Product from "../views/admin/Product.vue";
import Budgets from "../views/admin/Budget.vue";
import AdminContacts from "../views/admin/Contact.vue";
import Services from "../views/client/Services.vue";
import Vacancies from "../views/client/Vacancies.vue";
import Posts from "../views/client/Posts.vue";
import Budget from "../views/client/Budget.vue";
import AboutUs from "../views/client/AboutUs.vue";
import Courses from "../views/client/Courses.vue";
import Allies from "../views/client/Allies.vue";
import Contact from "../views/client/Contact.vue";
import Home from "../views/client/Home.vue";
import { VueEasyJwt } from "vue-easy-jwt";
const jwt = new VueEasyJwt();

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      hideHeader: false,
      hideSidebar: false,
      hideFooter: false,
      adminSite: false,
    },
  },
  {
    path: "/services/:id",
    name: "Services",
    component: Services,
    meta: {
      hideHeader: false,
      hideSidebar: false,
      hideFooter: false,
      adminSite: false,
    },
  },
  {
    path: "/vacancies/:id",
    name: "Vacancies",
    component: Vacancies,
    meta: {
      hideHeader: false,
      hideSidebar: false,
      hideFooter: false,
      adminSite: false,
    },
  },
  {
    path: "/posts/:id",
    name: "Posts",
    component: Posts,
    meta: {
      hideHeader: false,
      hideSidebar: false,
      hideFooter: false,
      adminSite: false,
    },
  },
  {
    path: "/budget",
    name: "Budget",
    component: Budget,
    meta: {
      hideHeader: false,
      hideSidebar: false,
      hideFooter: false,
      adminSite: false,
    },
  },
  {
    path: "/about-us",
    name: "AboutUs",
    component: AboutUs,
    meta: {
      hideHeader: false,
      hideSidebar: false,
      hideFooter: false,
      adminSite: false,
    },
  },
  {
    path: "/courses",
    name: "Courses",
    component: Courses,
    meta: {
      hideHeader: false,
      hideSidebar: false,
      hideFooter: false,
      adminSite: false,
    },
  },
  {
    path: "/allies",
    name: "Allies",
    component: Allies,
    meta: {
      hideHeader: false,
      hideSidebar: false,
      hideFooter: false,
      adminSite: false,
    },
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
    meta: {
      hideHeader: false,
      hideSidebar: false,
      hideFooter: false,
      adminSite: false,
    },
  },
  {
    path: "/admin/sign-in",
    name: "SignIn",
    component: SignIn,
    meta: {
      hideHeader: true,
      hideSidebar: true,
      hideFooter: false,
      adminSite: false,
    },
  },
  {
    path: "/admin",
    name: "Dashboard",
    redirect: "/admin/home",
    component: Dashboard,
    meta: {
      hideHeader: true,
      hideSidebar: true,
      hideFooter: true,
      adminSite: true,
    },
    children: [
      {
        path: "home",
        name: "DashboardHome",
        component: DashboardHome,
        meta: {
          hideHeader: true,
          hideSidebar: true,
          hideFooter: true,
          adminSite: true,
        },
      },
      {
        path: "social-media",
        name: "SocialMedia",
        component: SocialMedia,
        meta: {
          hideHeader: true,
          hideSidebar: true,
          hideFooter: true,
          adminSite: true,
        },
      },
      {
        path: "users",
        name: "Users",
        component: Users,
        meta: {
          hideHeader: true,
          hideSidebar: true,
          hideFooter: true,
          adminSite: true,
        },
      },
      {
        path: "audit",
        name: "Audit",
        component: Audit,
        meta: {
          hideHeader: true,
          hideSidebar: true,
          hideFooter: true,
          adminSite: true,
        },
      },
      {
        path: "settings",
        name: "Settings",
        component: Settings,
        meta: {
          hideHeader: true,
          hideSidebar: true,
          hideFooter: true,
          adminSite: true,
        },
      },
      {
        path: "service",
        name: "Service",
        component: Service,
        meta: {
          hideHeader: true,
          hideSidebar: true,
          hideFooter: true,
          adminSite: true,
        },
      },
      {
        path: "vacant",
        name: "Vacant",
        component: Vacant,
        meta: {
          hideHeader: true,
          hideSidebar: true,
          hideFooter: true,
          adminSite: true,
        },
      },
      {
        path: "post",
        name: "Post",
        component: Post,
        meta: {
          hideHeader: true,
          hideSidebar: true,
          hideFooter: true,
          adminSite: true,
        },
      },
      {
        path: "section",
        name: "Section",
        component: Section,
        meta: {
          hideHeader: true,
          hideSidebar: true,
          hideFooter: true,
          adminSite: true,
        },
      },
      {
        path: "fixed-terms",
        name: "FixedTerms",
        component: FixedTerms,
        meta: {
          hideHeader: true,
          hideSidebar: true,
          hideFooter: true,
          adminSite: true,
        },
      },
      {
        path: "product",
        name: "Product",
        component: Product,
        meta: {
          hideHeader: true,
          hideSidebar: true,
          hideFooter: true,
          adminSite: true,
        },
      },
      {
        path: "budgets",
        name: "Budgets",
        component: Budgets,
        meta: {
          hideHeader: true,
          hideSidebar: true,
          hideFooter: true,
          adminSite: true,
        },
      },
      {
        path: "contact",
        name: "Contacts",
        component: AdminContacts,
        meta: {
          hideHeader: true,
          hideSidebar: true,
          hideFooter: true,
          adminSite: true,
        },
      },
    ],
  },
  {
    path: "/reset",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      hideHeader: true,
      hideSidebar: true,
      hideFooter: false,
      adminSite: false,
    },
  },
  //REDIRECCIONES DE URL's DEL SITIO ANTERIOR
  { path: "/cuentas", redirect: "/posts/1" },
  { path: "/confirmation", redirect: "/posts/1" },
  { path: "/download", redirect: "/posts/1" },
  { path: "/downloader/:id", redirect: "/posts/1" },
  { path: "/signup", redirect: "/home" },
  { path: "/signin", redirect: "/home" },
  { path: "/signout", redirect: "/home" },
  { path: "/inicio", redirect: "/home" },
  { path: "/quienessomos", redirect: "/about-us" },
  { path: "/contacto", redirect: "/contact" },
  { path: "/serviciosprofesionales", redirect: "/services/1" },
  { path: "/soluciones", redirect: "/services/1" },
  { path: "/alianzas", redirect: "/allies" },
  { path: "/ofertalaboral", redirect: "/vacancies/1" },
  { path: "/talleres", redirect: "/courses" },
  { path: "/scripts", redirect: "/home" },
  { path: "/nagioscore", redirect: "/posts/1" },
  { path: "/nagiosxi", redirect: "/posts/1" },
  { path: "/nagios_new", redirect: "/budget" },
  { path: "/nagios", redirect: "/posts/1" },
  { path: "/helps/:keyword", redirect: "/home" },
  // FIN DE REDIRECCIONES
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
    meta: {
      hideHeader: true,
      hideSidebar: true,
      hideFooter: false,
      adminSite: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  to.matched.some((route) => {
    if (route.meta.adminSite) {
      if (info.getToken() !== undefined) {
        const token: string = info.getToken();
        if (jwt.isExpired(token)) {
          localStorage.removeItem("info");
          next({ path: "/admin/sign-in" });
        } else {
          next();
        }
      } else {
        next({ path: "/admin/sign-in" });
      }
    } else {
      next();
    }

    if (route.path == "/admin/sign-in") {
      if (info.getToken() !== undefined) {
        const token: string = info.getToken();
        if (jwt.isExpired(token)) {
          localStorage.removeItem("info");
          next();
        } else {
          next({ path: "/admin" });
        }
      } else {
        next();
      }
    }
  });
});

export default router;
